angular.module('app.controllers').controller('TasksCtrl', function (DataTablesFactory, tasksList, tasksListFilter) {
    const vm = this;

    vm.tasks = tasksList.list;
    vm.stats = tasksList.stats;
    vm.filter = tasksListFilter;

    vm.isUnfinished = (task) => task.status_id == variables.defaults.task_unfinished_id;

    vm.dt = DataTablesFactory.init({
        scope: vm,
    });
});
